import { useContext, useEffect, useMemo, useState } from "react"
import { ToastContext } from "../../../context/ToastContext";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";

export const useIssueTypeHierarchy = () => {
    const { showInfo, showSuccess, showError } = useContext(ToastContext);
    const [hierarchyData, setHierarchyData] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalAction, setModalAction] = useState('edit');
    const [currentItem, setCurrentItem] = useState(null);
    const [formValue, setFormValue] = useState({});
    const [confirmationPopup, setConfirmationPopup] = useState({
        data: "",
        show: false
    })

    useEffect(() => {
        getIssueTypeHierarchy();
    }, []);

    function buildHierarchy(flatArray) {
        const map = {};
        flatArray.forEach(item => map[item.issue_type_id] = { ...item, children: [] });
        const tree = [];

        flatArray.forEach(item => {
            if (item?.parent_issue_type_id === null) {
                tree.push(map[item?.issue_type_id]);
            } else {
                const parent = map[item?.parent_issue_type_id];
                if (parent) {
                    parent.children.push(map[item?.issue_type_id]);
                }
            }
        });
        return tree;
    }

    const renderItem = (item) => {
        const borderColors = ['#4caf50', '#2196f3', '#ff9800', '#c300ffff'];
        const borderColor = borderColors[item.pr_hierarchy_level + 1] || '#9e9e9e';

        return (
            <div className="levels">
                <div
                    key={item.issue_type_id}
                    className="items"
                    style={{
                      
                        marginBottom: 10,
                        borderTop: '1px solid var(--grid-border-color)',
                        borderRight: '1px solid var(--grid-border-color)',
                        borderBottom: '1px solid var(--grid-border-color)', 
                        background: 'var(--bg-color)',
                        color: 'var(--text-color)',
                        padding: '12px 18px',
                        borderRadius: 10,
                        boxShadow: '0 3px 8px rgba(0,0,0,0.08)',
                        marginBottom: 10,
                        position: 'relative',
                        userSelect: 'none',
                          borderLeft: `4px solid ${borderColor}`
                    }}
                >
                    <div className="d-flex justify-content-between align-items-center">
                        <span style={{ fontWeight: '600' }}>{item.issue_type_name}</span>
                        <div className="d-flex gap-2">
                            <button className="rounded bg-success px-2 py-1 text-white border-0" onClick={() => openModal('add', item)}>Add</button>
                            <button className="rounded bg-primary px-2 py-1 text-white border-0" onClick={() => { openModal('edit', item); setFormValue(item) }} >Edit</button>
                            <button className="rounded bg-danger px-2 py-1 text-white border-0" onClick={() => setConfirmationPopup({
                                show: true,
                                data: item
                            })}>Delete</button>
                        </div>
                    </div>

                </div>
                {item.children.length > 0 && item.children.map(child => renderItem(child))}
            </div>
        );
    };

    const openModal = (action, item) => {
        setModalAction(action);
        setCurrentItem(item);
        setModalVisible(true);
    };

    const handleDelete = async (item) => {
        function getAllIssueTypeIds(node) {
            let ids = [];
            function recurse(currentNode) {
                ids.push(currentNode.issue_type_id);
                if (currentNode.children && currentNode.children.length > 0) {
                    currentNode.children.forEach(child => recurse(child));
                }
            }
            recurse(node);
            return ids;
        }
        try {
            const payload = {
                "issue_type_ids": getAllIssueTypeIds(item)?.toString()
            }
            const res = await services.getInvokeRemote("POST", Urls("DELETEISSUETYPEHIERARCHY"), payload)
            if (!res?.body?.error_status) {
                showSuccess('Success', res.body.message);
                setConfirmationPopup({ show: false, data: "" })
                getIssueTypeHierarchy();
            } else {
                showError("Error", res.body.errorMessage);
            }
        } catch (error) {
            console.error("Error", error);
        }
    };

    const handleSave = async () => {
        if (_.isEqual(formValue, currentItem)) {
            showInfo("info", "No changes made");
            return;
        }
        if (!formValue?.issue_type_name?.trim()) {
            showInfo("Info", 'Please enter a valid name');
            return;
        }
        if (!formValue?.issue_type_description?.trim()) {
            showInfo("Info", 'Please enter a description');
            return;
        }
        try {
            const payload = {
                "issue_type_id": formValue?.issue_type_id || 0,
                "parent_issue_type_id": currentItem?.issue_type_id || 0,
                "issue_type_name": formValue?.issue_type_name,
                "issue_type_description": formValue?.issue_type_description,
                "is_subtask": true,
                "hierarchy_level": currentItem?.pr_hierarchy_level !== undefined ? currentItem?.pr_hierarchy_level + 1 : -1
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTISSUETYPEHIERARCHY"), payload)
            if (!res?.body?.error_status) {
                showSuccess('Success', res.body.message);
                setModalVisible(false);
                setCurrentItem(null);
                setFormValue({});
                getIssueTypeHierarchy();
            } else {
                showError("Error", res.body.errorMessage);
            }
        } catch (error) {
            console.error("Error", error);
        }
    };

    const getIssueTypeHierarchy = async () => {
        try {
            const res = await services.getInvokeRemote("GET", Urls("GETISSUETYPEHIERARCHY"));
            if (!res?.body?.error_status && res?.body?.data?.issue_type_hierarchy_list) {
                const data = buildHierarchy(res?.body?.data?.issue_type_hierarchy_list)
                setHierarchyData(data)
            } else {
                setHierarchyData([])
            }
        } catch (error) {
            console.error("error", error);
        }
    }


    return useMemo(() => ({
        formValue, hierarchyData, renderItem, modalVisible, setModalVisible, modalAction, setFormValue, handleSave, confirmationPopup, setConfirmationPopup, handleDelete
    }), [formValue, hierarchyData, renderItem, modalVisible, setModalVisible, modalAction, setFormValue, handleSave, confirmationPopup, setConfirmationPopup, handleDelete])
}